import { EntityModel } from '@/interfaces'
import {
  ALL_ACCOMMODATION_ADDONS_QUERY,
  CREATE_ACCOMMODATION_ADDON_MUTATION,
  DELETE_ACCOMMODATION_ADDON_MUTATION,
  FORCE_DELETE_ACCOMMODATION_ADDON_MUTATION,
  SINGLE_ACCOMMODATION_ADDON_QUERY,
  UPDATE_ACCOMMODATION_ADDON_MUTATION,
} from './graphql'
import travelPricingServiceCalculationSettingsEntity from '@/entities/travelPricingServiceCalculationSettings/entity'
import travelPricingMandatorySettingsEntity from '@/entities/travelPricingMandatorySettings/entity'

const ratioAccommodationAddonModel: EntityModel = {
  name: 'accommodationAddon',
  namePlural: 'accommodationAddons',
  uniqueName: 'ratioAccommodationAddon',
  uniqueNamePlural: 'ratioAccommodationAddons',
  path: 'travel/pricing/adaptors/ratio/accommodation_addon',
  baseUrl: '/travel/pricing/adaptors/ratio/accommodation_addons',
  translationPrefix: 'entities:ratioAccommodationAddon.',
  getDisplayName: (values: any) => {
    return values.label
  },
  gql: {
    getAll: ALL_ACCOMMODATION_ADDONS_QUERY,
    getSingle: SINGLE_ACCOMMODATION_ADDON_QUERY,
    create: CREATE_ACCOMMODATION_ADDON_MUTATION,
    update: UPDATE_ACCOMMODATION_ADDON_MUTATION,
    delete: DELETE_ACCOMMODATION_ADDON_MUTATION,
    forceDelete: FORCE_DELETE_ACCOMMODATION_ADDON_MUTATION,
  },
  attributes: {
    ratioServiceNo: {
      name: 'ratioServiceNo',
      label: 'entities:ratioAccommodationAddon.attributes.ratioServiceNo.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    name: {
      name: 'name',
      label: 'entities:ratioAccommodationAddon.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    label: {
      name: 'label',
      label: 'entities:ratioAccommodationAddon.attributes.label.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    info: {
      name: 'info',
      label: 'entities:ratioAccommodationAddon.attributes.info.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      maxLength: 255,
      validationType: 'string',
      validations: [],
    },
    calculationSettings: {
      name: 'calculationSettings',
      label: 'entities:ratioAccommodationAddon.attributes.calculationSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingServiceCalculationSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    mandatorySettings: {
      name: 'mandatorySettings',
      label: 'entities:ratioAccommodationAddon.attributes.mandatorySettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingMandatorySettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default ratioAccommodationAddonModel
